// Глобальный сервис статусов длительных процессов (генерация, перегенерация, тощо)
export type ProcessResult = 'success' | 'failed' | 'cancelled'

export interface GenerationStatus {
  projectId: number
  title: string
  startedAt: number
  lastUpdateAt: number
  isActive: boolean
  progress?: number // %
  totalTasks?: number
  completedTasks?: number
  failedTasks?: number
  etaSeconds?: number
  currentTask?: string
  statusText?: string
  result?: ProcessResult
}

type GenerationListener = (status: GenerationStatus | null) => void

class ProcessStatusService {
  private generationStatus: GenerationStatus | null = null
  private generationListeners: GenerationListener[] = []

  subscribeGeneration(listener: GenerationListener) {
    this.generationListeners.push(listener)
    // Немедленно отправляем текущее состояние
    try { listener(this.generationStatus) } catch {}
    return () => {
      const idx = this.generationListeners.indexOf(listener)
      if (idx > -1) this.generationListeners.splice(idx, 1)
    }
  }

  getGeneration(): GenerationStatus | null {
    return this.generationStatus
  }

  private notifyGeneration() {
    for (const l of this.generationListeners) {
      try { l(this.generationStatus) } catch {}
    }
  }

  startGeneration(projectId: number, title: string = 'Генерація TDH') {
    const now = Date.now()
    this.generationStatus = {
      projectId,
      title,
      startedAt: now,
      lastUpdateAt: now,
      isActive: true,
      progress: 0,
      statusText: 'Розпочато...'
    }
    this.notifyGeneration()
  }

  updateGeneration(projectId: number, update: Partial<Omit<GenerationStatus, 'projectId' | 'startedAt'>>) {
    if (!this.generationStatus || this.generationStatus.projectId !== projectId) return
    this.generationStatus = {
      ...this.generationStatus,
      ...update,
      lastUpdateAt: Date.now(),
    }
    this.notifyGeneration()
  }

  finishGeneration(projectId: number, result: ProcessResult, message?: string) {
    if (!this.generationStatus || this.generationStatus.projectId !== projectId) return
    this.generationStatus = {
      ...this.generationStatus,
      isActive: false,
      result,
      statusText: message || (result === 'success' ? 'Завершено успішно' : result === 'failed' ? 'Завершено з помилкою' : 'Скасовано')
    }
    this.notifyGeneration()
    // Автоочистка через 8 секунд
    setTimeout(() => {
      this.clearGeneration(projectId)
    }, 8000)
  }

  clearGeneration(projectId?: number) {
    if (projectId && this.generationStatus && this.generationStatus.projectId !== projectId) return
    this.generationStatus = null
    this.notifyGeneration()
  }
}

export const processStatusService = new ProcessStatusService()


